import { useContext } from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { t } from 'i18next'
import { ErrorModalContext } from '../../../context/errorModalContext'
import CustomModal from './customModal'
import WarningIcon from '../../../icons/warningIcon'

export default function ErrorModal() {
  const { showModal, errorMessage, setShowModal } = useContext(ErrorModalContext)
  return (
    <CustomModal
      open={showModal}
      handleClose={() => {
        setShowModal(false)
      }}
      variant="default"
    >
      <Box
        data-flex-container
        sx={{
          width: '100%',
          display: 'flex', 
          flexDirection: 'column',
        }}
      >
        <Box sx={{ 
          display: 'flex', 
          flexDirection: 'column',
          alignItems: 'center', 
          gap: '16px', 
          mb: '16px',
        }}>
          <Box>
            <WarningIcon />
          </Box>
          <Box sx={{ 
            display: 'flex', 
            justifyContent: 'center',
            width: '100%'
          }}>
            <Typography sx={{ textAlign: 'center', fontWeight: 'bold' }}>
              {t('common.error')}
            </Typography>
          </Box>
        </Box>

        <Box sx={{ 
          flex: 1, 
          overflow: 'auto',
          mb: '32px',
        }}>
          <Typography sx={{ 
            textAlign: 'center', 
            width: '100%',
            lineHeight: '24px',
            fontSize: {
              xs: '14px',
              md: '16px',
            },
            color: '#333',
          }}>
            {errorMessage}
          </Typography>
        </Box>
      </Box>
    </CustomModal>
  )
}
